module.exports = __webpack_public_path__ + "static/media/project_3.ca24e05c.webp";